@if (vm$ | async; as vm) {
  <ng-container *transloco="let t; read: 'revisions.detail'">
    <div class="componentContainer">
      <section class="xs12col componentHeader">
        <h1>{{t('title')}}</h1>
      </section>
      <kendo-tabstrip (tabSelect)="onTabSelect($event)">
        <kendo-tabstrip-tab [title]="t('tab.general')" [selected]="true">
          <ng-template kendoTabContent>
            <section class="oneCol">
              <div class="xs12col flexColumn">
                <form [formGroup]="revisionForm">
                  <div class="fieldsetWrapper margin-bottom-medium">
                    <div class="xs12col m4col">
                      <fieldset class="fieldsetContainer flexColumn">
                        <h2 class="padding-bottom-small">{{ t('customer') }}</h2>
                        <kendo-formfield [hidden]="!('Permissions.Revisions.Update' | permission)">
                          <kendo-label [text]="t('company')">*</kendo-label>
                          <kendo-dropdownlist
                            [data]="vm.companies"
                            textField="name"
                            valueField="id"
                            [defaultItem]="{ id: null, name: 'Kunde wählen' }"
                            formControlName="companyId"
                            [readonly]="!isNew"
                            [valuePrimitive]="true"
                            (valueChange)="onCompanyChange($event)">
                          </kendo-dropdownlist>
                        </kendo-formfield>
                        <kendo-formfield>
                          <kendo-label [text]="t('companyContact')"></kendo-label>
                          <kendo-textbox
                            formControlName="companyContact"
                            [readonly]="revisionStatus?.isFinalStatus == true"
                          ></kendo-textbox>
                        </kendo-formfield>
                      </fieldset>
                    </div>
                    <div class="xs12col  m4col">
                      <fieldset class="fieldsetContainer flexColumn">
                        <h2 class="padding-bottom-small">{{ t('revision') }}</h2>
                        <kendo-formfield>
                          <kendo-label text="{{ t('scheduledDate') }}*"></kendo-label>
                          <kendo-datepicker
                            formControlName="scheduledDate"
                            [placeholder]="t('scheduledDatePlaceholder')"
                            [readonly]="revisionStatus?.isFinalStatus == true"
                          ></kendo-datepicker>
                        </kendo-formfield>
                        <kendo-formfield [hidden]="!('Permissions.Revisions.Update' | permission)">
                          <kendo-label [text]="t('revisionStatus')">*</kendo-label>
                          <kendo-dropdownlist
                            [data]="vm.revisionStatus"
                            textField="name"
                            valueField="id"
                            [itemDisabled]="itemDisabled"
                            [value]="vm.revisionStatus?.[0]?.id"
                            [readonly]="revisionStatus?.isFinalStatus == true"
                            formControlName="revisionStatusId"
                            [valuePrimitive]="true">
                          </kendo-dropdownlist>
                        </kendo-formfield>
                      </fieldset>
                    </div>
                    <div class="xs12col m4col align-bottom">
                      <fieldset class="fieldsetContainer flexColumn">
                        <kendo-formfield>
                          <kendo-label [text]="t('orderNumber')"></kendo-label>
                          <kendo-textbox
                            formControlName="orderNumber"
                            [readonly]="revisionStatus?.isFinalStatus == true"
                          ></kendo-textbox>
                        </kendo-formfield>
                        <kendo-formfield>
                          <kendo-label [text]="t('orderNumberCustomer')"></kendo-label>
                          <kendo-textbox
                            formControlName="orderNumberCustomer"
                            [readonly]="revisionStatus?.isFinalStatus == true"
                          ></kendo-textbox>
                        </kendo-formfield>
                      </fieldset>
                    </div>
                    <div class="xs12col">
                      <fieldset class="fieldsetContainer flexRow">
                        <div class="xs12col s6col l3col">
                          <kendo-formfield>
                            <kendo-label [text]="t('remarks')"></kendo-label>
                            <kendo-textarea
                              formControlName="remarks"
                              [rows]="3"
                              [readonly]="revisionStatus?.isFinalStatus == true"
                              resizable="vertical"
                            ></kendo-textarea>
                          </kendo-formfield>
                        </div>
                        <div class="xs12col s6col l3col">
                          <kendo-formfield>
                            <kendo-label [text]="t('specifications')"></kendo-label>
                            <kendo-textarea
                              formControlName="specifications"
                              [rows]="3"
                              [readonly]="revisionStatus?.isFinalStatus == true"
                              resizable="vertical"
                            ></kendo-textarea>
                          </kendo-formfield>
                        </div>
                        <div class="xs12col s6col l3col">
                          <kendo-formfield>
                            <kendo-label [text]="t('process')"></kendo-label>
                            <kendo-textarea
                              formControlName="process"
                              [rows]="3"
                              [readonly]="revisionStatus?.isFinalStatus == true"
                              resizable="vertical"
                            ></kendo-textarea>
                          </kendo-formfield>
                        </div>
                        <div class="xs12col s6col l3col">
                          <kendo-formfield>
                            <kendo-label [text]="t('recommendations')"></kendo-label>
                            <kendo-textarea
                              formControlName="recommendations"
                              [rows]="3"
                              [readonly]="revisionStatus?.isFinalStatus == true"
                              resizable="vertical"
                            ></kendo-textarea>
                          </kendo-formfield>
                        </div>
                      </fieldset>
                    </div>
                    <div class="xs12col">
                      <fieldset class="fieldsetContainer">
                        <h2 class="xs12col">{{ t('roles') }}</h2>
                        <kendo-formfield [hidden]="!('Permissions.Revisions.Update' | permission)">
                          <kendo-label [text]="t('reporter')"></kendo-label>
                          <kendo-dropdownlist
                            [data]="vm.htecEmployees"
                            textField="fullName"
                            valueField="id"
                            [defaultItem]="{ id: null, firstName: t('reporterPlaceholder'), lastName:'' }"
                            formControlName="reporterId"
                            [readonly]="revisionStatus?.isFinalStatus == true"
                            [valuePrimitive]="true">
                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                              {{ dataItem.firstName }} {{ dataItem.lastName }}
                            </ng-template>
                          </kendo-dropdownlist>
                        </kendo-formfield>
                      </fieldset>
                    </div>
                    <fieldset class="fieldsetContainer">
                      <div class="xs12col m6col flexColumn padding-right-medium" [hidden]="revisionStatus?.isFinalStatus == true">
                        <p><strong>{{ t('availableEngineers') }}</strong></p>
                        @if (vm.availableHtecEmployeesForRevision; as engineers) {
                          <div class="availableElements">
                            @for (engineer of engineers; track engineer) {
                              <div class=" fill-width availableElement">
                                <span>{{ engineer.firstName || '' }}</span><span>{{ engineer.lastName || '-' }}</span>
                                <button
                                  kendoButton
                                  class="addIcon small"
                                  [hidden]="!('Permissions.Revisions.Update' | permission)"
                                  (click)="linkEngineer(engineer.id, engineer.firstName, engineer.lastName)">
                                  <div class="justify-end">
                                    <span class="icon">
                                      <img src="../../../assets/icons/add-icon.svg">
                                    </span>
                                  </div>
                                </button>
                              </div>
                            }
                          </div>
                        }
                      </div>
                      <div class="xs12col m6col flexColumn padding-left-medium">
                        <p><strong>{{ t('linkedEngineers') }}</strong></p>
                        <div formArrayName="engineers" class="availableElements">
                          @for (engineer of engineers.controls; track engineer; let i = $index) {
                            <div [formGroupName]="i" class="availableElement">
                              <input class="removeInputStyles"
                                formControlName="firstName"
                                [readonly]="true" />
                                <input class="removeInputStyles"
                                  formControlName="lastName"
                                  [readonly]="true" />
                                  <button
                                    kendoButton
                                    class="buttonSecondary"
                                    [hidden]="!('Permissions.Revisions.Update' | permission) || revisionStatus?.isFinalStatus == true"
                                    (click)="removeEngineer(engineer.value.id, i)">
                                    <img src="../../../assets/icons/delete-icon.svg">
                                  </button>
                                </div>
                              }
                            </div>
                          </div>
                        </fieldset>
                        <fieldset class="fieldsetContainer" [hidden]="revisionStatus?.isFinalStatus == true">
                          <div class="buttonContainer">
                            <button
                              kendoButton
                              class="buttonPrimary"
                              type="submit"
                              (click)="saveChanges()"
                              [hidden]="!('Permissions.Devices.Update' | permission)"
                              [disabled]="revisionForm?.invalid || !revisionForm?.dirty">
                              {{ isNew ? t('submit') : t('save') }}
                            </button>
                          </div>
                        </fieldset>
                      </div>
                    </form>
                    <button
                      (click)="completeRevisionDialogOpen()"
                      class="buttonSecondary"
                      [hidden]="isNew || !('Permissions.Revisions.Update' | permission) || revisionStatus?.isFinalStatus == true">
                      {{ t('complete') }}
                    </button>
                    <button
                      type="delete"
                      (click)="deletionDialogOpen()"
                      class="buttonSecondary delete buttonDelete margin-top-medium"
                      [hidden]="isNew || !('Permissions.Revisions.Delete' | permission) || revisionStatus?.isFinalStatus == true">
                      {{ t('delete') }}
                    </button>
                  </div>
                </section>
              </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="t('tab.devices')" [disabled]="isNew || !('Permissions.Devices.View' | permission)">
              <ng-template kendoTabContent>
                <app-revisions-detail-devices [revisionId]="revisionId" [revisionStatus]="revisionStatus" [companyId]="companyId" [tenantOnRevision]="tenantOnRevision"></app-revisions-detail-devices>
              </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="t('tab.wearingParts')" [disabled]="isNew || !('Permissions.WearingParts.Update' | permission)">
              <ng-template kendoTabContent>
                <app-revisions-detail-wearing-parts [revisionId]="revisionId" [revisionStatus]="revisionStatus"></app-revisions-detail-wearing-parts>
              </ng-template>
            </kendo-tabstrip-tab>
            <kendo-tabstrip-tab [title]="t('tab.documents')" [disabled]="isNew || !('Permissions.Attachments.View' | permission)">
              <ng-template kendoTabContent>
                <app-revisions-detail-documents [revisionId]="revisionId" [revisionStatus]="revisionStatus" [revisionReportDocumentId]="revisionReportDocumentId" [tenantOnRevision]="tenantOnRevision"></app-revisions-detail-documents>
              </ng-template>
            </kendo-tabstrip-tab>
          </kendo-tabstrip>
        </div>
        @if (deletionDialogOpened) {
          <kendo-dialog
            title="{{t('confirmDeletion')}}"
            (close)="deletionDialogClose('cancel')"
            [minWidth]="250"
            [width]="450">
            <p style="margin: 30px; text-align: center;">
              {{t('deletionMessage')}}
            </p>
            <kendo-dialog-actions>
              <button kendoButton (click)="deletionDialogClose('cancel')">{{ t('cancel') }}</button>
              <button kendoButton (click)="deletionDialogClose('delete')" themeColor="primary">{{ t('delete') }}
              </button>
            </kendo-dialog-actions>
          </kendo-dialog>
        }
        @if (completeRevisionDialogOpened) {
          <kendo-dialog
            title="{{t('confirmCompletion')}}"
            (close)="completeRevisionDialogClose('cancel')"
            [minWidth]="250"
            [width]="450">
            <p style="margin: 30px; text-align: center;">
              {{t('completeRevisionMessage')}}
            </p>
            <kendo-dialog-actions>
              <button kendoButton (click)="completeRevisionDialogClose('cancel')">{{ t('cancel') }}</button>
              <button kendoButton (click)="completeRevisionDialogClose('complete')" themeColor="primary">{{ t('complete') }}
              </button>
            </kendo-dialog-actions>
          </kendo-dialog>
        }
      </ng-container>
    }